import React from 'react';
import { SAVINGS_DATA } from '../../data/mock';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Receipt, Fuel, Clock, Home, TrendingDown, DollarSign } from 'lucide-react';

const iconMap = {
  Receipt: Receipt,
  Fuel: Fuel,
  Clock: Clock,
  Home: Home,
  TrendingDown: TrendingDown,
};

const SavingsSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
              {SAVINGS_DATA.title}
            </h2>
            
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
              {SAVINGS_DATA.items.map((item, index) => {
                const IconComponent = iconMap[item.icon] || DollarSign;
                return (
                  <div 
                    key={index}
                    className="bg-[#F8FAFC] rounded-xl p-4 border border-[#E2E8F0]"
                  >
                    <IconComponent className="w-6 h-6 text-[#0D9488] mb-2" />
                    <span className="text-sm font-medium text-[#111111]">{item.label}</span>
                  </div>
                );
              })}
            </div>

            <p className="mt-8 text-lg text-[#475569] leading-relaxed">
              {SAVINGS_DATA.summary}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link to="/pricing">
                <Button variant="outline" className="border-[#E2E8F0] text-[#111111] hover:border-[#0D9488]">
                  See Pricing Options
                </Button>
              </Link>
              <Link to="/book/waste">
                <Button className="bg-[#0D9488] hover:bg-[#0F766E] text-white">
                  Book Collection
                </Button>
              </Link>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-[#F0FDFA] to-[#E0F2FE] rounded-2xl p-8 lg:p-12">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#0D9488] text-white mb-6">
                  <DollarSign className="w-10 h-10" />
                </div>
                <div className="text-5xl md:text-6xl font-bold text-[#111111]">
                  $70-$100
                </div>
                <p className="mt-2 text-lg text-[#475569]">
                  average hidden cost per job
                </p>
                <div className="mt-8 p-4 bg-white rounded-xl border border-[#E2E8F0]">
                  <p className="text-sm text-[#64748B]">
                    Turn unpredictable costs into a simple, predictable logistics service
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SavingsSection;
